module.exports = __webpack_public_path__ + "static/media/search.3c86a9cb.svg";